import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { getChallengesApi, acceptChallengeApi } from 'yoda-interfaces/lib/Rewards/RewardsApi';
import {
    GET_CHALLENGES,
    GET_CHALLENGES_SUCCESS,
    ACCEPT_CHALLENGE,
    ACCEPT_CHALLENGE_SUCCESS,
    GET_CHALLENGES_ERROR,
    ACCEPT_CHALLENGE_ERROR,
} from '../actionTypes/ChallengesActionTypes';

export function* challengesSaga(action) {
    try {
        const challengesResponse = get(
            yield call(FactorySaga, getChallengesApi, action),
            'response',
            {}
        );
        const offers = get(challengesResponse, 'data.offers', null);
        if (Array.isArray(offers)) {
            yield put({ type: GET_CHALLENGES_SUCCESS, challenges: offers });
        } else if (challengesResponse.status !== 200) {
            throw challengesResponse;
        }
    } catch (error) {
        yield put({ type: GET_CHALLENGES_ERROR, error });
    }
}

export function* acceptChallengeSaga(action) {
    try {
        const acceptChallengeResult = yield call(FactorySaga, acceptChallengeApi, action);
        if (acceptChallengeResult.isSuccess) {
            const { offerId } = action.payload;
            yield put({ type: ACCEPT_CHALLENGE_SUCCESS, offerId });
            yield put({ type: GET_CHALLENGES });
        } else {
            yield put({
                type: ACCEPT_CHALLENGE_ERROR,
                error: 'Something went wrong. Please try again later',
            });
        }
    } catch (error) {
        yield put({
            type: ACCEPT_CHALLENGE_ERROR,
            error: 'Something went wrong. Please try again later',
        });
    }
}

export default function* watchChallengesSaga() {
    yield takeLatest(GET_CHALLENGES, challengesSaga);
    yield takeLatest(ACCEPT_CHALLENGE, acceptChallengeSaga);
}

watchChallengesSaga.sagaName = 'challengesSaga';
